export const ADD_POST = 'ADD_POST';
export const DELETE_POST = 'DELETE_POST';
export const FETCH_POSTS = 'FETCH_POSTS';
export const EDIT_POST = 'EDIT_POST';
export const FETCH_POST = 'FETCH_POST';

export const FETCH_USERS = 'FETCH_USERS';

export const FETCH_USER = 'FETCH_USER';
export const LOADING_USER = 'LOADING_USER';

export const FETCH_ALBUMS = 'FETCH_ALBUMS';
export const FETCH_ALBUM = 'FETCH_ALBUM';

export const FETCH_PHOTOS = 'FETCH_PHOTOS';
  
export const ADD_COMMENT = 'ADD_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const FETCH_COMMENTS = 'FETCH_COMMENTS';
export const EDIT_COMMENT = 'EDIT_COMMENT';

